import {BaseSpringServiceCB} from "@aiknow-srl/aik-ngx-http";
import {AlertOPEEnum} from "./AlertOPEEnum";
import {WeekCalendar} from "../../models/diagnostic/WeekCalendar";

class O {
  alertId!: number;
  calendar?: WeekCalendar | null;
  calendarForcedRecovery!: boolean;
  alarmCooldownSec?: number | null;
}

class I {
  alertId!: number;
}

export class GetWeekCalendarCB extends BaseSpringServiceCB {
  /**
   * Input
   */
  public i: I;
  /**
   * Output
   */
  public o: O;

  /**
   * Class constructor
   */
  constructor() {
    super(AlertOPEEnum.GetWeekCalendar);
    this.i = new I();
    this.o = new O();
  }
}
